import React, { FunctionComponent } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslate } from "../../../helpers";
import InformationIcon from "../../../assets/information.svg";
import { HelpDrawerWrapper } from "../../../components";
import { newBasicHelperDrawerAnalytics } from "../../../components/BasicHelperDrawerAnalytics";
import { AppContext } from "../../../app/store";

export const InNetworkHelperDrawer: FunctionComponent = () => {
  const t = useTranslate();
  const flags = useFlags();
  const { state } = React.useContext(AppContext);
  const inNetworkHelperDrawerAnalytics = newBasicHelperDrawerAnalytics({
    clickText: "What is this",
    state,
    flags,
  });

  return (
    <HelpDrawerWrapper
      toggleClassName="ds-u-display--inline-block ds-u-margin-bottom--3 ds-u-margin-left--1 ds-u-lg-margin-bottom--0 mct-hide-print"
      toggleText={
        <span className="ds-u-display--flex ds-u-align-items--center mct-u-white-space--nowrap">
          <span>
            <span className="ds-u-visibility--screen-reader">
              {t(
                "pharm_selection.in_network.show_only_preferred_in_network_pharmacies"
              )}
              :{" "}
            </span>
            {t("whats_this")}
          </span>
          <img src={InformationIcon} height="19" alt="" />
        </span>
      }
      drawerTitle={t("plan_card.pharmacies.more_about_pharmacy_cost_levels")}
      mctAnalytics={inNetworkHelperDrawerAnalytics}
    >
      <p>{t("plan_card.pharmacies.help_drawer.intro_text")}</p>
      <ul>
        <li>{t("plan_card.pharmacies.help_drawer.preferred_in_network")}</li>
        <li>{t("plan_card.pharmacies.help_drawer.standard_in_network")}</li>
        <li>{t("plan_card.pharmacies.help_drawer.out_of_network")}</li>
        <li>{t("plan_card.pharmacies.help_drawer.mail_order")}</li>
      </ul>
    </HelpDrawerWrapper>
  );
};
